import type { Competition } from '@/api/spec.ts';
import { mergeCompetitionCatalog } from './competition-catalog';
import { getMockCompetitions } from './mocks';

export function getLiveCompetition(catalog: Competition[], nowMs = Date.now()): Competition | undefined {
  return catalog.find((competition) => competition.starts_at <= nowMs && nowMs < competition.ends_at);
}

export function getTournamentNavPath(competitions: Competition[] | undefined, nowMs = Date.now()): string {
  const catalog = mergeCompetitionCatalog(competitions, getMockCompetitions());
  const live = getLiveCompetition(catalog, nowMs);
  return live ? `/tournaments/${live.slug}` : '/tournaments';
}
